<template>
  <div class="h6 mb-0">
    <!-- <div :content="errorLampDesc(lamp)"> -->
    <div>
        <!---- gestione nodo orfano -->
        <div v-if="lamp.cu_type == 'logicafm' && lamp.nodo_orfano==true" :content="errorLampDesc(lamp)" v-tippy="{ placement: 'top', arrow: true }">
            <b-iconstack :font-scale="scalefont">
                <b-icon stacked icon="wifi" style="color: violet;" scale="1"></b-icon>
                <b-icon stacked icon="slash" style="color: violet;" ></b-icon>      
            </b-iconstack>
        </div>
        <!-- gestione sistema sicuro -->
        <div v-else-if="lamp.cu_type == 'sicuro' && lamp.error_com_cpu_ak == 'ON'" :content="errorLampDesc(lamp)" v-tippy="{ placement : 'top',  arrow: true}">
            <b-iconstack :font-scale="scalefont">
                <b-icon stacked icon="slash" style="color:red"></b-icon>
                <b-icon stacked icon="arrow-left-right" style="color:red"></b-icon>
            </b-iconstack>
        </div>

        <!---- gestione tipo di errore -->
        <i v-else 
            :class="['fa', scale, dotClassLamp(lamp)]" 
            :content="errorLampDesc(lamp)" 
            v-tippy="{ placement: 'top', arrow: true }"
        />

    </div>
  </div>
</template>

<script>

export default {
  name: "IconErrorLamp",
  props: {
    lamp: {
      default: null
    },
    scale: {
      type: String,
      default: 'fa-2x'
    },
    scalefont: {
      type: String,
      default: '2.5'
    }
  },
  data() {
    return {
    };
  },
 
  mounted() {
    // console.log("IconErrorLamp lamp: ", this.lamp.id,  "centrale: ", this.lamp.cu_id, " scale: ", this.scale, " scalefont: ", this.scalefont);
  },
  methods: {
    dotClassLamp(device)
        {
            // console.log("dotClassLamp: ", device);
            var stato_lamp = null;
            
            //Check errore per lampada di illuminazione bluetooth
            if(device.cu_type == 'bluetooth' && device.autonomy=="??")
            {
                if (device.lampFail == "OFF" && device.errorBallastCom == "OFF")
                {
                   stato_lamp = "fa-check check-ok";
               
                   if(device.error_com == "ON")
                    {
                        stato_lamp = "fa-exclamation-circle check-com-err";
                    }
                }
                else
                {
                    stato_lamp = "fa-exclamation-circle check-err";
                }
            }    

            //Check errore per lampada di illuminazione centralizzata
            else if(device.device_function=="ILLUMINAZIONE" && device.cu_type != 'bluetooth')
            {
                if(device.error_com == "ON")
                {
                    stato_lamp = "fa-exclamation-circle check-com-err";
                }
                else if (device.error_overpower == "OFF" && device.error_underpower == "OFF" && device.error_overvoltage == "OFF" && device.error_comm_radio_lamp == "OFF" && device.error_undervoltage == "OFF" && device.error_hardware == "OFF")
                {
                    stato_lamp = "fa-check check-ok";
                }
                else 
                {
                    stato_lamp = "fa-exclamation-circle check-err";
                }
            }

            //Check errore per sensori o altro
            else if(device.device_function=="ALTRO" && device.cu_type != 'bluetooth')
            {
                stato_lamp = "fa-check check-ok";
            }

            //Check errori per SICURO: lampade, charger
            else if (device.cu_type == 'sicuro')
            {
                if (device.error_com_ak_lamp == 'ON')
                {
                    stato_lamp= "fa-exclamation-circle check-com-err";
                }
                else if (device.error_dali_com === 'ON' || device.error_dali_hardware === 'ON' || device.error_dali_lamp === 'ON' || device.error_hardware === 'ON' ||
                         device.error_id_duplicate === 'ON' || device.error_lamp_programming === 'ON' || device.error_led_open === 'ON' || device.error_led_full_short === 'ON' ||
                         device.error_led_partial_short === 'ON' || device.error_low_voltage === 'ON' || device.error_polarity_reverse === 'ON' || 
                         device.error_under_threshold === 'ON' || device.error_line_fuse === 'ON') {
                    stato_lamp= "fa-exclamation-circle check-err";
                }
                else {
                    stato_lamp = "fa-check check-ok";
                }
            }

            //Check errore per lampada di emergenza centralizzata e bluetooth
            else
            {
                
                if(device.error_com == "ON")
                {
                    stato_lamp= "fa-exclamation-circle check-com-err";
                }
                else if (device.error_batt_short == "OFF" && device.error_batt_test == "OFF" && (!device.error_batt_test_auto || device.error_batt_test_auto == "OFF") && device.error_hardware == "OFF" && device.error_led == "OFF")
                {
                    stato_lamp = "fa-check check-ok";
                }
                else
                {
                    stato_lamp= "fa-exclamation-circle check-err";
                }
            }

            return stato_lamp
        },


        errorLampDesc(device)
        {

            var stato_lamp_desc = "";

            if(device.error_com == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_com");
            else if(device.error_comm_radio_lamp == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_comm_radio_lamp");    
            else if (device.error_batt_short == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_batt_short");
            else if(device.error_batt_test == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_batt_test");
            else if (device.error_batt_test_auto == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_batt_test_auto");
            else if(device.error_hardware == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_hardware");
            else if(device.error_led == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_led");
            else if(device.error_overpower == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_overpower");   
            else if(device.error_underpower == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_underpower");    
            else if(device.error_overvoltage == "ON")
                stato_lamp_desc=this.$t("details_lamp.lamp_error_overvoltage");   
            else if(device.error_undervoltage == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_undervoltage");            
            else if(device.errorBallastCom == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_error_ballast_com");
            else if(device.lampFail == "ON")
                stato_lamp_desc= this.$t("details_lamp.lamp_fail");    
            else if(device.nodo_orfano==true)
                stato_lamp_desc= this.$t("details_lamp.lamp_orphan_error");
            //SICURO Lampade
            else if (device.error_com_ak_lamp == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_com_ak_lamp');
            else if (device.error_com_cpu_ak == 'ON')
                stato_lamp_desc = this.$t('details_cu_modal.cu_error_com_cpu_AK');
            else if (device.error_line_fuse == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_line_fuse');
            else if (device.error_dali_com == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_dali_com');
            else if (device.error_dali_hardware == 'ON')
                stato_lamp_desc = this.$t('details_lamp.error_dali_hardware');
            else if (device.error_dali_lamp == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_dali_lamp');
            else if (device.error_hardware == 'ON')
                stato_lamp_desc = this.$t('details_lamp.error_dali_hardware');
            else if (device.error_id_duplicate == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_duplicate');
            else if (device.error_lamp_programming == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_programming');
            else if (device.error_led_open == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_led_open');
            else if (device.error_led_full_short == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_led_full_short');
            else if (device.error_led_partial_short == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_led_partial_short');
            else if (device.error_low_voltage =='ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_low_voltage');
            else if (device.error_polarity_reverse == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_reverse_polarity');                         
            else if (device.error_under_threshold == 'ON')
                stato_lamp_desc = this.$t('details_lamp.lamp_error_under_threshold');                 
            else
                stato_lamp_desc= this.$t("details_lamp.lamp_no_error");
         
            return stato_lamp_desc
        },
      }
   
  }
  
</script>
